import React from "react";
import "./style.scss";

export const AudioS3Card = ({ name, description, file, fileName, extension='wav', size='md', fileSize, bucket }) => {
    // const downloadBook = () => {
    //       const element = document.createElement("a");
    //       element.href = `${bucket}/${fileName}`;
    //       element.download = `${fileName}`;
    //       element.click();
    //   }

    const downloadBook = async () => {
        const response = await fetch(`${bucket}/${fileName}`);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      };
      
      
  return (
    <div className={size === 'md' ? "content-box" : "content-box size"}>
      <h1 className="card-title">{name}</h1>
      <p className="card-content">{description}</p>
      <div>
        <div>
          <span className="see-more" onClick={downloadBook}>Download ({fileSize})</span>
          {/* <span className="see-more">Learn More</span> */}
        </div>
      </div>
    </div>
  );
};